import {
  getStats,
  getFinishedBackup, getEntraStats
} from "@/services/api/app/office/stats";
import {ENTRA_TYPE_MAP} from "@/store/app/office/entraTypeMap";

const defaultState = () => ({
  stats: {},
  entraStats: {},
  finishedBackup: false,
});

export default {
  namespaced: true,

  actions: {
    getStats({commit}, data) {
      return getStats(data)
        .then(stats => {
          commit('setStats', stats);
          return stats;
        })
    },
    getEntraStats({commit}, data) {
      return getEntraStats(data)
        .then(stats => {
          commit('setEntraStats', stats);
          return stats;
        })
    },
    getFinishedBackup({commit}) {
      return getFinishedBackup()
        .then(finishedBackup => {
          commit('setFinishedBackup', finishedBackup);
          return finishedBackup;
        })
    },
  },

  mutations: {
    setStats(state, stats) {
      state.stats = stats
    },
    setEntraStats(state, stats) {
      state.entraStats = stats;
    },
    setFinishedBackup(state, finishedBackup) {
      state.finishedBackup = finishedBackup
    },
  },

  getters: {
    getTotalProtectedData: (state) => () => {
      const
        driveStats = state.stats?.driveStats?.totalData || 0,
        exchangeStats = state.stats?.exchangeStats?.totalData || 0,
        siteStats = state.stats?.siteStats?.totalData || 0,
        teamStats = state.stats?.teamStats?.totalData || 0,
        entraStats = state.stats?.entraStats?.totalData || 0,

        totalData = driveStats + exchangeStats + siteStats + teamStats + entraStats

      return totalData
    },
    getDashboardStats: (state) => {
      const processedStats = { ...state.stats };

      if (state.entraStats) {
        processedStats.entraObjectStats = state.entraStats.entraObjectStats || [];

        state.entraStats?.entraObjectStats?.forEach(item => {
          const key = ENTRA_TYPE_MAP[item.objectType];

          if (key) {
            processedStats[key] = {
              ...item,
              lastBackups: item.lastBackups,
              totalObjects: item.total,
              activeUsers: item.total
            };
          }
        });
      }

      return processedStats;
    },
  },


  state: defaultState,
}
